import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ViewType = 'internal' | 'dealer' | 'fleet-manager'

export const useViewStore = defineStore('view', () => {
  const currentView = ref<ViewType>('internal')

  const setView = (view: ViewType) => {
    currentView.value = view
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedView', view)
    }
  }

  const initializeView = () => {
    if (typeof window !== 'undefined') {
      const savedView = localStorage.getItem('selectedView') as ViewType
      if (savedView && ['internal', 'dealer', 'fleet-manager'].includes(savedView)) {
        currentView.value = savedView
      }
    }
  }

  const getViewDisplayName = (view?: ViewType) => {
    const viewToUse = view || currentView.value
    switch (viewToUse) {
      case 'internal':
        return 'Internal'
      case 'dealer':
        return 'Dealer'
      case 'fleet-manager':
        return 'Fleet Manager'
      default:
        return 'Internal'
    }
  }

  const getViewPermissions = () => {
    switch (currentView.value) {
      case 'internal':
        return {
          canViewOrders: true,
          canCreateOrders: true,
          canManageDealer: false,
          canManageFleet: false
        }
      case 'dealer':
        return {
          canViewOrders: true,
          canCreateOrders: true,
          canManageDealer: true,
          canManageFleet: false
        }
      case 'fleet-manager':
        return {
          canViewOrders: true,
          canCreateOrders: true,
          canManageDealer: true,
          canManageFleet: true
        }
      default:
        return {
          canViewOrders: false,
          canCreateOrders: false,
          canManageDealer: false,
          canManageFleet: false
        }
    }
  }

  return {
    currentView,
    setView,
    initializeView,
    getViewDisplayName,
    getViewPermissions
  }
}, {
  persist: {
    key: 'view-store',
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    pick: ['currentView']
  } 
})